import { useMemo } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { BackButton } from './BackButton';

interface Props extends BoxProps {
    title: string;
    onClick?: () => void;
}

export const Headline = ({ title, className, sx, onClick, ...props }: Props) => {
    const styles = useMemo(
        () =>
            ({
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                position: 'relative',
                ...sx,
                mb: 3,
            } as BoxProps['sx']),
        [sx],
    );
    return (
        <Box sx={styles} {...props}>
            <BackButton onClick={onClick} sx={{ position: 'absolute', order: -1, left: 0 }}>
                Back
            </BackButton>
            <Typography variant="h4">{title}</Typography>
        </Box>
    );
};
